/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-26 10:23:41 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-09-26 15:39:35
 */

<template>
  <a-modal
    v-model:open="open"
    title="Log"
    :width="1000"
    :footer="null"
    :get-container="container"
    @ok="hideLogModal"
    @cancel="hideLogModal"
  >
    <a-spin :spinning="logLoading">
      <a-table
        :data-source="logList"
        :columns="LogTableColumns"
        bordered
        :pagination="logPagination"
        :scroll="{ y: 480 }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'createTime'">
            {{ moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script setup>
import moment from 'moment'
import { message } from 'ant-design-vue'
import { advertiser } from '../server/index'
import { ref } from 'vue'

const open = ref(true)
const logList = ref([])
const logLoading = ref(false)
const props = defineProps({
  id: { type: [String, Number], required: true },
  container: { type: [Object, String], default: undefined },
  showAffiliateLogId: { type: [String, Number], default: -1 },
})
const emit = defineEmits(['hideLogModal'])
const LogTableColumns = [
  {
    title: 'User Name',
    dataIndex: 'editorName',
    key: 'editorName',
  },
  {
    title: 'Actions',
    dataIndex: 'operation',
    key: 'operation',
  },
  {
    title: 'Updated time',
    dataIndex: 'createTime',
    key: 'createTime',
  },
]
const hideLogModal = () => {
  emit('hideLogModal')
}
const getLog = (page = 1) => {
  const params = { advertiserId: props.id, page, size: 10 }

  if (props.showAffiliateLogId != -1) {
    params['subType'] = 'aff_relation'
    params['subId'] = props.showAffiliateLogId
  }

  logLoading.value = true
  advertiser.getLogList(params).then((res) => {
    logLoading.value = false
    if (res.success) {
      logList.value = res.data
      logPagination.value.current = page

      if (page == 1) {
        logPagination.value.total = res.total
      }
    } else {
      message.error('网络错误，请重试')
    }
  })
}
const logPagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  onChange: (page) => {
    getLog(page)
  },
})
getLog(1)
</script>